import React from 'react';
import ReactLoading from 'react-loading';

export default function Loader(props){
	return(
			<div className='w-full h-full flex justify-center items-center'>
				<ReactLoading type={props.type || 'bars'} color={props.color || '#39A3F2'} />
			</div>
		)
}